module.exports = __webpack_public_path__ + "96874c7cf4e0c52303893a0f9f9c441f.png";